export default __webpack_public_path__ + "static/media/Icon-list-black.81aab624.svg";